import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container: HTMLElement = document.getElementById('root')!;
const root = createRoot(container);

root.render(<App />);
